
import { createSlice } from '@reduxjs/toolkit';
import { fetcherGet, fetcherPost, fetcherPut } from "../utils/fetcher";
import { setLoader } from './commonSlice';
import { APIS, mentorPayout, mentorProfilePayout } from '../utils/constants';
import { getUserInfo, getQuestionsSavedAnswers, getStudentProfileInfo } from './studentSlice';

const initialState = {
    mentorInfo: {},
    matchedMentor: [],
    matchedMentorInStepper: [],
    mentorBio: {},
    viewSingleMentorBioOnMentorListb2b: {},
    allMentorList: [],
    mentorSearchResult: [],
    filterOptions: [],
    filterResult: [],
    MatchedMentorsOnBooking: [],
    matchedMentorOnMessage: [],
    openMentorAvailabilityTab: false,
    mentorAverageRating: [],
    matchMentorSessionId: []
}

const mentorSlice = createSlice({
    name: 'mentor',
    initialState,
    reducers: {
        setMentorInfo: (state, action) => {
            state.mentorInfo = action.payload;
        },
        setMatchedMentor: (state, action) => {
            state.matchedMentor = action.payload;
        },
        setStepperMentor: (state, action) => {
            state.matchedMentorInStepper = action.payload;
        },
        setMatchedMentorsOnBooking: (state, action) => {
            state.MatchedMentorsOnBooking = action.payload;
        },
        setMatchedMentorOnMessage: (state, action) => {
            state.matchedMentorOnMessage = action.payload;
        },
        setMentorBio: (state, action) => {
            state.mentorBio = action.payload;
        },
        setViewSingleMentorBioOnMentorListb2b: (state, action) => {
            state.viewSingleMentorBioOnMentorListb2b = action.payload;
        },
        setAllMentors: (state, action) => {
            state.allMentorList = action.payload;
        },
        setMentorSearchResult: (state, action) => {
            state.mentorSearchResult = action.payload
        },
        setFilterOptions: (state, action) => {
            state.filterOptions = action.payload
        },
        setFilterResult: (state, action) => {
            state.filterResult = action.payload
        },
        setMentorEarnings: (state, action) => {
            state.mentorEarnings = action.payload
        },
        setMentorAvailabilityTab: (state, action) => {
            state.openMentorAvailabilityTab = action.payload
        },
        setMentorAvageRating: (state, action) => {
            state.mentorAverageRating = action.payload
        },
        setMatchMentorSessionId: (state, action) => {
            state.matchMentorSessionId = action.payload
        }
    }
});

export function getMentorfInfo(userId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.GET_MENTOR_INFO + userId)
            .then((res) => {
                dispatch(setMentorInfo(res?.data));
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function matchedMentors(flag = false) {
    return (dispatch) => {
        // dispatch(setLoader(true));
        const apiUrl = flag ? `${APIS.MATCHED_MENTORS}${flag}` : APIS.MATCHED_MENTORS;
        fetcherGet(apiUrl)
            .then((res) => {
                if (flag) {
                    dispatch(setMatchedMentorsOnBooking(res?.data?.matchMentors));
                    dispatch(setMatchedMentorOnMessage(res?.data?.matchMentors));
                } else {
                    dispatch(setMatchedMentor(res?.data?.matchMentors));
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function matchedMentorsInStepper(cb) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.MATCHED_NEW_MENTORS)
            .then((res) => {
                // dispatch(setMatchedMentor(res?.data?.matchMentors));
                dispatch(setMatchedMentor(res?.data?.matchMentors?.getMatchMentorsData));
                dispatch(setMatchMentorSessionId(res?.data?.matchMentors?.activeSessionId));
                if (cb) { 
                    cb(res?.data?.matchMentors?.getMatchMentorsData?.length < 2 ? false : true);
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                if (cb) { cb(false);}
                dispatch(setLoader(false));
            });
    };
}

export function mentorBioDetails(userId, setOpenPopUp) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.MENTOR_BIO_DETAILS + userId)
            .then((res) => {
                if (setOpenPopUp) {
                    setOpenPopUp(true); //to open dialogpopup of mentor details when response is received
                }
                dispatch(setMentorBio(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function viewSingleMentorBioOnMentorList(userId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.MENTOR_BIO_DETAILS + userId)
            .then((res) => {
                dispatch(setViewSingleMentorBioOnMentorListb2b(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getAllMentors(page = 1, limit = 9, search = "", is_match_exclude = true) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.GET_ALL_MENTOR_LIST}?search=${search}&page=${page}&limit=${limit}&is_match_exclude=${is_match_exclude}`;
        fetcherGet(url)
            .then((res) => {
                dispatch(setAllMentors(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getFilterOptions() {
    return (dispatch) => {
        // dispatch(setLoader(true));
        fetcherGet(APIS.GET_FILTER_LIST)
            .then((res) => {
                dispatch(setFilterOptions(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getFilterResult(selectedIds, page = 1, search = "", limit=9,is_match_exclude = true) {
    const background = selectedIds?.Background?.join(',') || "";
    const majorCategory = selectedIds?.['Major Category']?.join(',') || "";
    const mentor_expertise = selectedIds?.['Mentor Expertise']?.join(',') || "";
    const colleges = selectedIds?.Colleges?.join(',') || "";
    const languages = selectedIds?.Languages?.join(',') || "";

    let URL = APIS.FILTER_MENTOR_LIST + `?page=${page}&search=${search}&limit=${limit}&is_match_exclude=${is_match_exclude}&background=${background}&majors=${majorCategory}&mentor_expertise=${mentor_expertise}&colleges=${colleges}&languages=${languages}`;

    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(URL)
            .then((res) => {
                dispatch(setFilterResult(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}


export function searchMentors(query) {
    let URL = query ? APIS.SEARCH_MENTOR + query : APIS.SEARCH_MENTOR
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(URL)
            .then((res) => {
                dispatch(setMentorSearchResult(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function updateMentorBio() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.UPDATE_MENTOR_BIO_DETAILS)
            .then(() => {
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function putRetakeQuizFlag() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.PUT_RETAKE_QUIZ_FLAG)
            .then(() => {
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function updateMentor(userId, payload) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.UPDATE_MENTOR, payload)
            .then(() => {
                dispatch(getUserInfo());
                dispatch(setLoader(false));
                dispatch(getQuestionsSavedAnswers())
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function updateMentorBySuperAdmin(mentorId, payload) {
    let str = APIS?.UPDATE_MENTOR;
    let url = str?.slice(0, -1);
    if(mentorId){
       url = url + `?user_id=${mentorId}`
    }
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(url , payload)
            .then(() => {
                dispatch(setLoader(false));
                dispatch(getStudentProfileInfo(mentorId))
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function postAddRemoveMentor(payload, handlePopUp, msg) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.ADD_OR_REMOVE_MY_MENTOR, payload)
            .then(() => {
                dispatch(setLoader(false));
                if (msg) {
                    handlePopUp(msg);
                }
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function getMentorPayout(callBack, isOnboarding = false) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let URL = isOnboarding ? APIS.MENTOR_PAYOUT + mentorPayout.redirect : APIS.FINISH_STRIPE + mentorProfilePayout.redirect
        fetcherGet(URL)
            .then((res) => {
                if (callBack && typeof callBack === "function") {
                    callBack(res?.data)
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getMentorEarnings(params = {}) {
    const {month, page = 1, limit = 10 } = params;
    const date = new Date();
    const year = date.getFullYear();
    const newDate = `${month}-${year}`;
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS.MENTOR_EARNINGS}?date=${newDate}&page=${page}&limit=${limit}`)
            .then((res) => {
                dispatch(setMentorEarnings(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function updateMentorStatus(payload, handlePopUp, msg) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.UPDATE_MENTOR_STATUS, payload)
            .then(() => {
                dispatch(setLoader(false));
                if (msg) {
                    handlePopUp(msg);
                }
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export function updateMentorStatusAction(payload, handlePopUp, msg) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.UPDATE_MENTOR_STATUS_ACTION, payload)
            .then(() => {
                dispatch(setLoader(false));
                if (msg) {
                    handlePopUp(msg);
                }
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

//func to update/toggle mentor's background check status
export function updateMentorBackgroundStatus(payload, callback) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.UPDATE_MENTOR_BACKGROUND_STATUS, payload)
            .then((res) => {
                if(callback){ callback(res) }
                dispatch(getStudentProfileInfo(payload?.mentor_id))
                // dispatch(setLoader(false)); //commenting this as in above api it is setting loader false
            })
            .catch((err) => {
                if(callback){ callback(err) }
                dispatch(setLoader(false));
            });
    };
}

export function updateMentorConsignment(payload) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.PUT_CONSIGNMENT, payload)
            .then(() => {
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getMentorConsignment() {
    return (dispatch) => {
        fetcherGet(APIS.GET_CONSIGNMENT)
            .then(() => {
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function mentorAvarageRating(mentorId) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(`${APIS.AVERAGE_MENTOR_RATING}?mentor_id=` + mentorId)
            .then((res) => {
                dispatch(setMentorAvageRating(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function createCalUser(payload) {
    return (dispatch) => {
        fetcherPost(APIS?.CREATE_CAL_USER, payload)
            .then(() => {
                dispatch(setLoader(false));
            })
            .catch((err) => {
                console.error(err);
                dispatch(setLoader(false));
            });
    };
}

export const { setMentorInfo, setMatchedMentor, setStepperMentor, setMentorBio, setAllMentors, setMentorSearchResult, setFilterOptions, setFilterResult,
    setMatchedMentorsOnBooking, setMatchedMentorOnMessage, setViewSingleMentorBioOnMentorListb2b, setMentorEarnings, setMentorAvailabilityTab, setMentorAvageRating, setMatchMentorSessionId } = mentorSlice.actions;
export default mentorSlice.reducer;